import { AI_NEXT_ACTIONS, formatAiNextAction, getAiNextActionColor } from "../utils/displayFormatters";
import LeadStatusFlow from "./LeadStatusFlow";

const LABEL =
  "text-[10px] font-semibold uppercase tracking-wider text-text-secondary";

/**
 * Where the lead stands and what comes next: the status stepper with Close
 * lead, and the next-action select beside it. It sits below the act row, so
 * it reads as a record of the work, not the task itself.
 *
 * The view owns the status writes and their modals: Contacted opens the
 * contact modal, Not Interested and Not Applicable open the loss-reason modal.
 */
const LeadStatusControl = ({
  lead,
  onStatusChange,
  onCategoryChange,
  onScheduleAppointment,
  onNextActionChange,
  disabled = false,
}) => (
  <div className="flex flex-wrap items-start gap-x-6 gap-y-3 rounded-md border border-border bg-white px-4 py-3">
    <div>
      <div className={`${LABEL} mb-1.5`}>Status</div>
      <LeadStatusFlow
        currentStatus={lead.status}
        currentCategory={lead.lead_category || "prospect"}
        onStatusChange={onStatusChange}
        onCategoryChange={onCategoryChange}
        onScheduleAppointment={onScheduleAppointment}
      />
    </div>

    {/* Staff correction of the AI's next action. Stored in next_action, which
        wins over ai_next_action. */}
    <div className="min-w-[12rem] flex-1">
      <div className={`${LABEL} mb-1.5`}>Next action</div>
      <select
        value={lead.next_action || ""}
        disabled={disabled}
        onChange={(e) => onNextActionChange(e.target.value)}
        aria-label="Next action"
        className={`max-w-full px-3 py-1 text-xs font-medium rounded-full border-0 cursor-pointer disabled:opacity-60 ${getAiNextActionColor(
          lead.effective_next_action,
        )}`}
      >
        <option value="">
          {lead.ai_next_action
            ? `Use AI: ${formatAiNextAction(lead.ai_next_action)}`
            : "Not set"}
        </option>
        {AI_NEXT_ACTIONS.map((a) => (
          <option key={a.key} value={a.key}>
            {a.label}
          </option>
        ))}
      </select>
      {lead.next_action && lead.ai_next_action && lead.next_action !== lead.ai_next_action ? (
        <p className="mt-1 text-xs text-gray-400">
          AI said {formatAiNextAction(lead.ai_next_action)}
        </p>
      ) : (
        lead.ai_follow_up_reason && (
          <p className="ph-mask mt-1 text-xs italic text-gray-500">
            {lead.ai_follow_up_reason}
          </p>
        )
      )}
    </div>
  </div>
);

export default LeadStatusControl;
